import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Store, Actions, ofActionDispatched, Select } from '@ngxs/store';
import { SignUp, SignUpSuccess, SignUpFailure, LoginWithGoogle, LoginFailure, LoginSuccess, CheckSession } from '../../state/auth/auth.actions';
import { SignUpModel } from '../../models/sign-up.model';
import { GroupConfigModel } from '../../models/group-config.model';
import { plainToClass } from 'class-transformer';
import { takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { AuthState } from '../../state/auth/auth.state';
import { Observable, Subject } from 'rxjs';
import { AuthService } from '../../auth.service';
import { SocialUser } from 'angularx-social-login';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { GoogleLoginModel } from '../../models/google-login.model';

@Component({
  selector: 'app-sign-up-page',
  templateUrl: './sign-up-page.component.html',
  styleUrls: ['./sign-up-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignUpPageComponent implements OnInit, OnDestroy {
  @Select(AuthState.getLoading)
  loading$: Observable<boolean>;

  get firstName() { return this.form.get('firstName'); }
  get lastName() { return this.form.get('lastName'); }
  get email() { return this.form.get('email'); }
  get password() { return this.form.get('password'); }

  form: FormGroup;
  errorMessage: SafeHtml;
  groupConfig: GroupConfigModel;
  
  private ngUnsubscribe = new Subject();

  constructor(
    private formBuilder: FormBuilder,
    private store: Store,
    private actions: Actions,
    private snackbar: MatSnackBar,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute

  ) {
    this.groupConfig = this.authService.getGroupConfigFromRoute(this.activatedRoute.snapshot);

    this.form = this.formBuilder.group({
      'firstName': ['', Validators.required],
      'lastName': ['', Validators.required],
      'email': ['', Validators.email],
      'password': ['', [Validators.minLength(8), Validators.maxLength(255)]],
      'groupCode': [this.groupConfig.groupCode]
    });
  }

  ngOnInit() {
    

    this.actions
      .pipe(
        ofActionDispatched(SignUpSuccess),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(() => this.handleSignUpSuccess());

    this.actions
      .pipe(
        ofActionDispatched(SignUpFailure),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((action: SignUpFailure) => {
        this.handleSignUpFailure(action.error);
      });

    // this.actions
    //   .pipe(
    //     ofActionDispatched(LoginFailure),
    //     takeUntil(this.ngUnsubscribe)
    //   )
    //   .subscribe((action: LoginFailure) => {
    //     this.handleSignUpFailure(action.error);
    //   });

    // this.actions
    //   .pipe(
    //     ofActionDispatched(LoginSuccess),
    //     takeUntil(this.ngUnsubscribe)
    //   )
    //   .subscribe((action: LoginSuccess) => this.handleSignUpSuccess());
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleGoogleClick() {
    this.authService.authenticateWithGoogle()
      .then((value: SocialUser) => {
        
        // Group code values
        const login: GoogleLoginModel = {
          ...new GoogleLoginModel(value.idToken),
          ...this.groupConfig
        };
        login.groupCode = this.form.get('groupCode').value;
        
        this.store.dispatch(new LoginWithGoogle(login));
      })
      .catch((error) => {
        if (error instanceof String) {
        } else if (error instanceof HttpErrorResponse) {
          this.handleSignUpFailure(error);
        }
      });
  }

  handleFormSubmit() {
    this.errorMessage = '';

    if (this.form.valid) {
      this.signup();
    }
  }

  handleSignUpSuccess() {
    this.snackbar.open('Successfully created account');
    this.store.dispatch(new CheckSession());
  }

  handleSignUpFailure(error: HttpErrorResponse) {
    const message: string = error.error.error.message;
    this.errorMessage = this.sanitizer.bypassSecurityTrustHtml(message);
  }

  signup() {
    // Get form and group values
    const signUp = plainToClass(SignUpModel, {
      ...this.form.value,
      ...this.groupConfig
    } as Object);
    signUp.groupCode = this.form.get('groupCode').value;

    this.store.dispatch(new SignUp(signUp));
  }
}
